module.exports = __webpack_public_path__ + "img/55.ebc3c0ad.png";